<div class="container">
  <section class="w-lg-75">
    <h1>{{ formTitle }}</h1>
    <p>{{ description }}</p>
    <div class="alert alert-info mb-3" role="alert">
      <p>
        <strong>User type: </strong>Select the correct user type (ATF Employees <strong>& TFOs</strong> select ATF Field Division or ATF HQ, as appropriate)
      </p>
      <p><strong>User role: </strong>Select the appropriate role from the dropdown</p>
      <ul class="list-unstyled ms-3">
        <li>Viewer: Read Only</li>
        <li>Editor: Read/Write</li>
        <li>Power User: Read/Write/All Exports/Bulk RMS Data Import/Manage Data</li>
        <li>Application Administrator: Read/Write/All Exports/Bulk RMS Data Import/Manage Data/Manage Users</li>
      </ul>
      <p>Contact your Field Division POC or <a href="mailto:ness_support@atf.gov?subject=NESS Account Registration support request" class="blue-hyperlink">NESS_Support&#64;atf.gov</a> if you have questions or need assistance.</p>
    </div>
    <div class="alert alert-success mb-3" role="alert" *ngIf="requestSubmitted">
      <p>
        <span class="fw-bold">Success:</span> You have submitted your registration request for NESS and is pending approval. You will receive an email notification once the approval process is completed.
      </p>
    </div>
    <form [formGroup]="registrationForm" *ngIf="!requestSubmitted">
      <div class="row align-items-top gy-sm-3 gx-sm-2 mb-3">
        <label for="Email" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end">Email address:</label>
        <div class="col-md-9 col-sm-8 col-12">
          <input id="Email" readonly aria-readonly="true" type="text" formControlName="Email" class="form-control-plaintext" />
        </div>
        <label for="FirstName" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field">First name:</label>
        <div class="col-md-9 col-sm-8 col-12">
          <input type="text" formControlName="FirstName" class="form-control" id="FirstName" required aria-required="true" />
          <div class="invalid-feedback">
            Please enter your first name.
          </div>
        </div>
        <label for="LastName" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field">Last name:</label>
        <div class="col-md-9 col-sm-8 col-12">
          <input type="text" formControlName="LastName" class="form-control" id="LastName" required aria-required="true" />
          <div class="invalid-feedback">
            Please enter your last name.
          </div>
        </div>
        <label for="PhoneNumber" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end">Phone number:</label>
        <div class="col-md-9 col-sm-8 col-12">
          <p-inputMask type="text" formControlName="PhoneNumber" styleClass="form-control" mask="(999) 999-9999" id="PhoneNumber"></p-inputMask>
        </div>
        <label for="UserType" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field">User type:</label>
        <div class="col-md-9 col-sm-8 col-12">
          <select #userTypeSelect id="UserType" class="form-select" formControlName="UserTypeID" required aria-required="true" (change)="onSelectUserType(userTypeSelect.value)">
            <option value="">Select a user type</option>
            <option *ngFor="let userType of userTypes" value="{{userType.Id}}">{{userType.UserTypeDsiaplyName}}</option>
          </select>
          <div class="invalid-feedback">
            Please provide the user type.
          </div>
        </div>
        <label for="JobTitle" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field">Job Title:</label>
        <div class="col-md-9 col-sm-8 col-12">
          <select #jobTitleSelect id="JobTitle" class="form-select" formControlName="JobTitleID" required aria-required="true" (change)="onSelectJobTitle(jobTitleSelect.value)">
            <option value="">Select a job title</option>
            <option *ngFor="let jobTitle of filteredJobTitles" value="{{jobTitle.ID}}">{{jobTitle.JobTitle}} ({{jobTitle.Abbreviation}})</option>
          </select>
          <div class="invalid-feedback">
            Please provide the job title.
          </div>
        </div>
        <label for="OtherJobTitle" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field" [hidden]="!showOtherJobTitle">Other (100 chars max):</label>
        <div class="col-md-9 col-sm-8 col-12" [hidden]="!showOtherJobTitle">
          <input type="text" formControlName="OtherJobTitle" class="form-control" id="OtherJobTitle" maxlength="100" required aria-required="true" />
          <div class="invalid-feedback">
            Please enter other job title.
          </div>
        </div>
        <label for="FieldDivisionID" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field" [hidden]="!showFieldDivision">ATF Field Division:</label>
        <div class="col-md-9 col-sm-8 col-12" [hidden]="!showFieldDivision">
          <select #fieldDivisionSelect id="FieldDivisionID" formControlName="FieldDivisionID" class="form-select" (change)="onSelectFieldDivision(fieldDivisionSelect.value)" required aria-required="true">
            <option value="">Select a field division</option>
            <option *ngFor="let fieldDiv of fieldDivisions$ | async" value="{{fieldDiv.FieldDivisionID}}">{{fieldDiv.FieldDivisionName}}</option>
          </select>
          <div class="invalid-feedback">
            Please provide the field division.
          </div>
        </div>
        <label for="FDGroupID" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field" [hidden]="!showFieldDivision">Group:</label>
        <div class="col-md-9 col-sm-8 col-12" [hidden]="!showFieldDivision">
          <select id="FDGroupID" formControlName="FDGroupID" class="form-select" required aria-required="true">
            <option value="">Select a group</option>
            <option *ngFor="let fdGroup of filteredFDGroup" value="{{fdGroup.IntelligenceReportATFReferralGroupsID}}" [class.text-muted]="fdGroup.Inactive" [disabled]="fdGroup.Inactive">{{fdGroup.GroupName}}  ({{fdGroup.Inactive | booleanTransform: 'Inactive' :'Active'}})</option>
          </select>
          <div class="invalid-feedback">
            Please provide the field division.
          </div>
        </div>
        <label for="StateID" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field" [hidden]="!showAgency">Agency state:</label>
        <div class="col-md-9 col-sm-8 col-12" [hidden]="!showAgency">
          <select #stateSelect id="StateID" class="form-select" formControlName="StateID" required aria-required="true" (change)="onSelectState(stateSelect.value)">
            <option value="">Select state</option>
            <ng-container *ngIf="lookupService.usStates$ | async as usStates">
              <option *ngFor="let state of usStates" value="{{state.StateID}}">{{state.StateName}}</option>
            </ng-container>
          </select>
          <div class="invalid-feedback">
            Please provide the agency state.
          </div>
        </div>
        <label for="AgencyID" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field" [hidden]="!showAgency">Agency:</label>
        <div class="col-md-9 col-sm-8 col-12" [hidden]="!showAgency">
          <select id="AgencyID" class="form-select" formControlName="AgencyID" required aria-required="true">
            <option value="">Select agency</option>
            <option *ngFor="let agency of filteredAgencies" value="{{agency.AgencyID}}">{{agency.AgencyName}}</option>
          </select>
          <div class="invalid-feedback">
            Please provide the agency.
          </div>
        </div>
        <ng-container formArrayName="Roles" *ngFor="let item of Roles.controls;let i = index">
          <ng-container [formGroupName]="i">
            <label for="{{'RoleName'+i}}" class="col-form-label col-md-3 col-sm-4 col-12 text-sm-end required-field">User role:</label>
            <div class="col-md-9 col-sm-8 col-12">
              <select id="{{'RoleName'+i}}" class="form-select" formControlName="Name" required aria-required="true">
                <option value="">Select a user role.</option>
                <option *ngFor="let role of filteredRoles" value="{{role.Name}}">{{role.Name}}</option>
              </select>
              <div class="invalid-feedback">
                Please provide the user role.
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="offset-md-3 offset-sm-4 col-md-9 col-sm-8 col-12">
        <button type="button" [disabled]="!registrationForm.valid" (click)="registerUser()" class="btn btn-active mb-2">Submit registration</button>
        <button type="button" class="btn btn-secondary mb-2" (click)="onReset()">Reset</button>
      </div>
    </form>
  </section>
</div>
